import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUpIcon, UsersIcon, BarChartIcon, ClockIcon, FileTextIcon, LinkedinIcon, YoutubeIcon, ArrowRightIcon, MailIcon } from 'lucide-react';
import Button from '../components/Button';
import SkillsSection from '../components/SkillsSection';
import ResumeModal from '../components/ResumeModal';
import { skillsData, careerHighlights } from '../data/SkillsData';
const Home = () => {
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false);
  const icons = {
    TrendingUpIcon: <TrendingUpIcon className="h-6 w-6" data-id="element-398" />,
    UsersIcon: <UsersIcon className="h-6 w-6" data-id="element-399" />,
    LineChartIcon: <BarChartIcon className="h-6 w-6" data-id="element-400" />,
    ClockIcon: <ClockIcon className="h-6 w-6" data-id="element-401" />
  };
  const handleEmailContact = () => {
    window.open('mailto:bhavinisapra4@gmail.com?subject=Reaching%20out%20from%20your%20portfolio', '_blank');
  };
  return <div className="bg-gray-900 text-white" data-id="element-402">
      {/* Hero Section */}
      <div className="relative bg-gray-900" data-id="element-403">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-404">
          <div className="py-16 md:py-20 lg:py-24" data-id="element-405">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-406">
              <div data-id="element-407">
                <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-408">
                  <span className="block" data-id="element-409">Product Builder</span>
                  <span className="block text-indigo-400" data-id="element-410">
                    Building Scalable Digital Products That Make Sense
                  </span>
                </h1>
                <p className="mt-6 text-lg text-gray-300 max-w-3xl" data-id="element-411">
                  Product thinker at heart, passionate about solving real-world
                  problems at the intersection of business, design, and
                  technology.
                </p>
                <div className="mt-8 flex flex-wrap gap-4" data-id="element-412">
                  <button onClick={() => setIsResumeModalOpen(true)} className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-413">
                    <FileTextIcon className="mr-2 h-5 w-5" data-id="element-414" />
                    Resume
                  </button>
                  <button onClick={handleEmailContact} className="inline-flex items-center px-6 py-3 border border-gray-600 shadow-sm text-base font-medium rounded-md text-gray-300 bg-gray-800 hover:bg-gray-700" data-id="element-415">
                    <MailIcon className="mr-2 h-5 w-5" data-id="element-416" />
                    Email Me
                  </button>
                </div>
              </div>
              <div className="relative" data-id="element-417">
                <div className="aspect-w-4 aspect-h-5 rounded-xl overflow-hidden shadow-xl" data-id="element-418">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q5VgxF1KJycKyYFo9s6vQQ/1758896736330.jpg" alt="Bhavini Sapra" className="w-full h-full object-cover" data-id="element-419" />
                </div>
                <div className="absolute -bottom-4 -right-4 h-24 w-24 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-lg" data-id="element-420">
                  7+ Years
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Resume Modal */}
      <ResumeModal isOpen={isResumeModalOpen} onClose={() => setIsResumeModalOpen(false)} imageUrl="https://cdn.magicpatterns.com/uploads/4RsNrq4eG87zuo1zFRsTx2/IMG_2396.jpg" data-id="element-421" />

      {/* Career Highlights Section */}
      <section className="py-16 bg-gray-800" data-id="element-422">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-423">
          <div className="text-center" data-id="element-424">
            <h2 className="text-3xl font-bold text-white" data-id="element-425">Career Highlights</h2>
            <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-300" data-id="element-426">
              Key achievements from my 7+ years in product management
            </p>
          </div>
          <div className="mt-12 grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-4" data-id="element-427">
            {careerHighlights.map((highlight, index) => <div key={index} className="bg-gray-900 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-700" data-id="element-428">
                <div className="h-12 w-12 rounded-md bg-indigo-900 text-indigo-400 flex items-center justify-center mb-4" data-id="element-429">
                  {icons[highlight.icon as keyof typeof icons]}
                </div>
                <h3 className="text-lg font-medium text-white" data-id="element-430">
                  {highlight.title}
                </h3>
                <p className="mt-2 text-base text-gray-300" data-id="element-431">
                  {highlight.description}
                </p>
              </div>)}
          </div>
          <div className="mt-10 text-center" data-id="element-432">
            <Link to="/my-story" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-433">
              Read My Story
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-434" />
            </Link>
          </div>
        </div>
      </section>
      {/* Skills Section */}
      <SkillsSection skills={skillsData} data-id="element-435" />
      {/* Beyond Work Section */}
      <section className="py-16 bg-gray-800" data-id="element-436">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-437">
          <div className="text-center" data-id="element-438">
            <h2 className="text-3xl font-bold text-white" data-id="element-439">Beyond Work</h2>
            <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-300" data-id="element-440">
              I share insights as a content creator, simplifying product and AI
              concepts for aspiring PMs and career switchers
            </p>
          </div>
          <div className="mt-12 grid gap-8 grid-cols-1 md:grid-cols-3" data-id="element-441">
            <div className="bg-gray-900 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-700" data-id="element-442">
              <div className="h-12 w-12 rounded-md bg-indigo-900 text-indigo-400 flex items-center justify-center mb-4" data-id="element-443">
                <LinkedinIcon className="h-6 w-6" data-id="element-444" />
              </div>
              <h3 className="text-lg font-medium text-white" data-id="element-445">
                LinkedIn Content
              </h3>
              <p className="mt-2 text-base text-gray-300" data-id="element-446">
                Weekly insights on product management best practices and career
                development strategies
              </p>
              <a href="https://www.linkedin.com/in/bhavinisapra/" target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center text-indigo-400 hover:text-indigo-300" data-id="element-447">
                Follow me on LinkedIn
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-448" />
              </a>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-700" data-id="element-449">
              <div className="h-12 w-12 rounded-md bg-indigo-900 text-indigo-400 flex items-center justify-center mb-4" data-id="element-450">
                <YoutubeIcon className="h-6 w-6" data-id="element-451" />
              </div>
              <h3 className="text-lg font-medium text-white" data-id="element-452">
                Being a Product Manager
              </h3>
              <p className="mt-2 text-base text-gray-300" data-id="element-453">
                Insights on the product management role and how to excel in this
                dynamic field
              </p>
              <a href="https://youtu.be/cjcCFuvx1no?si=0jwA-_In-g66p05P" target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center text-indigo-400 hover:text-indigo-300" data-id="element-454">
                Watch on YouTube
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-455" />
              </a>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-700" data-id="element-456">
              <div className="h-12 w-12 rounded-md bg-indigo-900 text-indigo-400 flex items-center justify-center mb-4" data-id="element-457">
                <YoutubeIcon className="h-6 w-6" data-id="element-458" />
              </div>
              <h3 className="text-lg font-medium text-white" data-id="element-459">
                Product Owner Collaboration
              </h3>
              <p className="mt-2 text-base text-gray-300" data-id="element-460">
                Strategies for effective collaboration in product development
                teams
              </p>
              <a href="https://youtu.be/cDUyaobQooo?si=stMfOGov_uZbZD3k" target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center text-indigo-400 hover:text-indigo-300" data-id="element-461">
                Watch on YouTube
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-462" />
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-indigo-900" data-id="element-463">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-464">
          <div className="text-center" data-id="element-465">
            <h2 className="text-3xl font-bold text-white" data-id="element-466">
              Ready to collaborate?
            </h2>
            <p className="mt-4 max-w-2xl mx-auto text-lg text-indigo-100" data-id="element-467">
              From crafting user-first products to sharing ideas on tech and AI,
              I enjoy turning thoughts into things that resonate. If you think
              we can build, learn, or create together — I'd love to collaborate.
            </p>
            <div className="mt-8" data-id="element-468">
              <Link to="/contact" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-indigo-900 bg-white hover:bg-indigo-50" data-id="element-469">
                Get in Touch
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Home;